import {
  BulletinRecipientTarget,
  BulletinDeliveryMethod,
  BulletinAttachmentMode,
} from 'further-types/lp/bulletin-update';

export const bulletinRecipientTargetLabels = {
  [BulletinRecipientTarget.AllClosedInvestors]: 'All closed investors',
  [BulletinRecipientTarget.AllUnclosedInvestors]: 'All unclosed investors',
  [BulletinRecipientTarget.AllInvestors]: 'All investors',
  [BulletinRecipientTarget.SelectedInvestors]: 'Selected investors',
};

export const bulletinRecipientTargetOptions = Object.values(
  BulletinRecipientTarget,
).map((value) => ({
  value,
  label: bulletinRecipientTargetLabels[value],
}));

export const bulletinDeliveryMethodLabels = {
  [BulletinDeliveryMethod.Email]: 'Email',
  [BulletinDeliveryMethod.Portal]: 'Portal',
  [BulletinDeliveryMethod.EmailAndPortal]: 'Email and portal',
};

export const bulletinDeliveryMethodOptions = Object.values(
  BulletinDeliveryMethod,
).map((value) => ({
  value,
  label: bulletinDeliveryMethodLabels[value],
}));

export const bulletinAttachmentModeLabels = {
  [BulletinAttachmentMode.SendToAll]: 'Send attachments to all',
  [BulletinAttachmentMode.UniquePerInvestor]: 'Unique attachments per investor',
};

export const bulletinAttachmentModeOptions = Object.values(
  BulletinAttachmentMode,
).map((value) => ({
  value,
  label: bulletinAttachmentModeLabels[value],
}));
